import { render } from "./ReviewBadge.vue?vue&type=template&id=d82c50c0"
import script from "./ReviewBadge.vue?vue&type=script&lang=js"
export * from "./ReviewBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__